export function getShortExecutedLoadName(field: string) {
  return field.replace('formattedData.executedLoads.', '')
}
